/**
 * ┌────────────────────────────────────────────────────────────────────────────
 * │ @author                    Alexandre DE FREITAS MARTINS
 * ├────────────────────────────────────────────────────────────────────────────
 * │ @file          MinecraftDecorations.jsx
 * │ @path          client/src/components/MinecraftDecorations.jsx
 * │ @description   Minecraft themed decorative elements
 * │ @version       1.0.0
 * │
 * │ @date          2025-10-21
 * ├────────────────────────────────────────────────────────────────────────────
 * │ @copyright     (c) 2025
 * └────────────────────────────────────────────────────────────────────────────
 */

export default function MinecraftDecorations() {
    return (
        <>
            {/* Floating Grass Blocks */}
            <div className="minecraft-block" style={{ bottom: '20%', left: '10%' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" shapeRendering="crispEdges">
                    {/* Dirt body */}
                    <rect x="0" y="20" width="100" height="80" fill="#8b5a2b" />
                    <rect x="10" y="40" width="10" height="10" fill="#6b4423" />
                    <rect x="60" y="60" width="10" height="10" fill="#6b4423" />
                    <rect x="30" y="75" width="10" height="10" fill="#6b4423" />
                    {/* Grass top */}
                    <rect x="0" y="0" width="100" height="20" fill="#5d8a3a" />
                    <rect x="20" y="0" width="10" height="20" fill="#6f9f47" />
                    <rect x="70" y="0" width="10" height="20" fill="#6f9f47" />
                    {/* Jagged grass edge */}
                    <rect x="0" y="20" width="10" height="10" fill="#5d8a3a" />
                    <rect x="30" y="20" width="10" height="10" fill="#5d8a3a" />
                    <rect x="50" y="20" width="10" height="10" fill="#5d8a3a" />
                    <rect x="80" y="20" width="10" height="10" fill="#5d8a3a" />
                    {/* Outline */}
                    <rect x="0" y="0" width="100" height="100" fill="none" stroke="#3b2a1a" strokeWidth="2" />
                </svg>
            </div>

            <div className="minecraft-block" style={{ bottom: '30%', right: '15%' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" shapeRendering="crispEdges">
                    {/* Dirt body */}
                    <rect x="0" y="20" width="100" height="80" fill="#8b5a2b" />
                    <rect x="45" y="35" width="10" height="10" fill="#6b4423" />
                    <rect x="15" y="60" width="10" height="10" fill="#6b4423" />
                    <rect x="75" y="45" width="10" height="10" fill="#6b4423" />
                    {/* Grass top */}
                    <rect x="0" y="0" width="100" height="20" fill="#5d8a3a" />
                    <rect x="10" y="0" width="10" height="20" fill="#6f9f47" />
                    <rect x="55" y="0" width="10" height="20" fill="#6f9f47" />
                    {/* Jagged grass edge */}
                    <rect x="10" y="20" width="10" height="10" fill="#5d8a3a" />
                    <rect x="40" y="20" width="10" height="10" fill="#5d8a3a" />
                    <rect x="65" y="20" width="10" height="10" fill="#5d8a3a" />
                    <rect x="90" y="20" width="10" height="10" fill="#5d8a3a" />
                    {/* Outline */}
                    <rect x="0" y="0" width="100" height="100" fill="none" stroke="#3b2a1a" strokeWidth="2" />
                </svg>
            </div>

            {/* Walking Creeper */}
            <div className="minecraft-creeper" style={{ bottom: '30%' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" shapeRendering="crispEdges">
                    {/* Face background */}
                    <rect x="0" y="0" width="100" height="100" fill="#4CAF50" />
                    {/* Eyes */}
                    <rect x="12.5" y="12.5" width="25" height="25" fill="#141414" />
                    <rect x="62.5" y="12.5" width="25" height="25" fill="#141414" />
                    {/* Nose notch */}
                    <rect x="37.5" y="37.5" width="25" height="12.5" fill="#141414" />
                    {/* Mouth */}
                    <rect x="25" y="50" width="50" height="25" fill="#141414" />
                    <rect x="25" y="75" width="12.5" height="12.5" fill="#141414" />
                    <rect x="62.5" y="75" width="12.5" height="12.5" fill="#141414" />
                </svg>
            </div>

            <div className="minecraft-creeper" style={{ bottom: '18%', animationDelay: '7s' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" shapeRendering="crispEdges">
                    {/* Face background */}
                    <rect x="0" y="0" width="100" height="100" fill="#4CAF50" />
                    {/* Eyes */}
                    <rect x="12.5" y="12.5" width="25" height="25" fill="#141414" />
                    <rect x="62.5" y="12.5" width="25" height="25" fill="#141414" />
                    {/* Nose notch */}
                    <rect x="37.5" y="37.5" width="25" height="12.5" fill="#141414" />
                    {/* Mouth */}
                    <rect x="25" y="50" width="50" height="25" fill="#141414" />
                    <rect x="25" y="75" width="12.5" height="12.5" fill="#141414" />
                    <rect x="62.5" y="75" width="12.5" height="12.5" fill="#141414" />
                </svg>
            </div>

            {/* Floating TNT */}
            <div className="minecraft-tnt" style={{ bottom: '15%', left: '50%' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" shapeRendering="crispEdges">
                    <rect x="10" y="10" width="80" height="80" fill="#c62828" />
                    <rect x="10" y="10" width="80" height="15" fill="#8a1f1f" />
                    <rect x="10" y="75" width="80" height="15" fill="#8a1f1f" />
                    <rect x="10" y="40" width="80" height="20" fill="#f5f5f5" />
                    <rect x="20" y="45" width="8" height="10" fill="#1a1a1a" />
                    <rect x="34" y="45" width="8" height="10" fill="#1a1a1a" />
                    <rect x="46" y="45" width="8" height="10" fill="#1a1a1a" />
                    <rect x="60" y="45" width="8" height="10" fill="#1a1a1a" />
                    <rect x="72" y="45" width="8" height="10" fill="#1a1a1a" />
                    {/* Fuse */}
                    <rect x="46" y="0" width="8" height="10" fill="#3b2a1a" />
                </svg>
            </div>

            {/* Floating Diamond */}
            <div className="minecraft-diamond" style={{ top: '20%', right: '10%' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" shapeRendering="crispEdges">
                    <rect x="20" y="0" width="20" height="10" fill="#5ce1e6" />
                    <rect x="10" y="10" width="40" height="10" fill="#5ce1e6" />
                    <rect x="0" y="20" width="60" height="10" fill="#8ff0f5" />
                    <rect x="10" y="30" width="40" height="10" fill="#5ce1e6" />
                    <rect x="20" y="40" width="20" height="10" fill="#3bb8bd" />
                    <rect x="25" y="50" width="10" height="10" fill="#3bb8bd" />
                </svg>
            </div>
        </>
    );
};
